exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#social-copir{width:100%;height:30px;position:fixed;left:0;bottom:40px;z-index:99}.soc-wrap{width:74%;min-width:1000px;height:100%;margin:auto}.soc{text-align:left}.soc img{width:15px;height:auto}.soc a{margin-left:10px}.cop,.soc{width:50%;float:left;height:100%}.cop{text-align:right}.cop img{width:100px;height:auto}@media (max-width:1024px){#social-copir{position:static;width:auto;padding:5vh}.soc-wrap{width:auto;min-width:0}.soc{pointer-events:none;display:block;position:fixed;z-index:9999;left:0;bottom:0;height:30px;padding:5vh;padding-bottom:2vh;opacity:0;transition:opacity .2s ease}.cop,.soc{width:100%}.cop{float:none}.cop img{width:80px}.mobile_menu_open .soc{opacity:1;transition:opacity .2s ease .4s;pointer-events:all;width:100%;background-color:#312f2f}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-776e455f","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SocialCopir.vue
// module id = 72
// module chunks = 0